<template>
  <div class="d-flex flex-column">
    <div
      class="d-flex type-container align-items-center position-relative cursor-pointer"
      style="padding: 0 1rem; overflow: hidden"
      v-for="(type, index) of typeList"
      :key="`type-${index}`"
      @click="selectTypeListener(index)"
    >
      <div class="icon iconfont" :class="type.icon"></div>
      <div
        class="d-flex flex-column"
        style="padding: 0 1rem"
      >
        <div>名称:{{ type.F_Name }}</div>
        <div>代号:{{ type.F_Code }}</div>
      </div>
      <label v-if="type.isSelect" class="el-upload-list__item-status-label">
        <i class="el-icon-upload-success el-icon-check"></i>
      </label>
    </div>
    <div
      class="d-flex align-items-center justify-content-center"
      style="margin-top: 1rem"
    >
      <el-button size="small" type="primary" @click="onSubmit">确认</el-button>
      <el-button size="small" @click="onCancel">取消</el-button>
    </div>
  </div>
</template>
<script>
import DiaFromMixin from '@/components/operating-maintenance/mixins/dia-form-mixin';

export default {
  name: 'order-type-select',
  mixins: [DiaFromMixin],
  props: {
    typeList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectType: null,
    };
  },
  methods: {
    selectTypeListener(index) {
      this.typeList.forEach((type) => {
        // eslint-disable-next-line no-param-reassign
        type.isSelect = false;
      });
      this.typeList[index].isSelect = true;
      this.selectType = this.typeList[index];
      this.$forceUpdate();
    },
    onCancel() {
      this.emitCloseDialog();
    },
    onSubmit() {
      if (!this.selectType) {
        this.$message({
          type: 'warning',
          message: '请选择工单类型',
        });
        return;
      }
      this.$emit('selectType', this.selectType);
      this.emitCloseDialog();
    },
  },
};
</script>
<style scoped>
.type-container {
  width: calc(100% - 2rem);
  height: 80px;
  border: 1px solid black;
  border-radius: 4px;
}
.type-container + .type-container {
  margin-top: 1rem;
}
.icon {
  font-size: 50px;
}
.el-upload-list__item-status-label {
  display: block;
  position: absolute;
  width: 46px;
  height: 26px;
  right: -17px;
  top: -7px;
  background: #13ce66;
  text-align: center;
  transform: rotate(45deg);
  box-shadow: 0 1px 1px #ccc;
}
.el-upload-list__item-status-label i {
  font-size: 12px;
  margin-top: 12px;
  transform: rotate(-45deg);
}
</style>
